// Curated, evergreen internal-linking maps. Intentional (reader-useful), not
// maximized for link count. Slugs verified against published blog_posts.

// Cornerstone Pennsylvania legal resource guides (surfaced on Resources + city pages).
export const CORE_PA_GUIDES = [
  { label: "Pennsylvania Statute of Limitations", slug: "pennsylvania-statute-of-limitations-injury-claims-explained" },
  { label: "Comparative Negligence (51% Bar)", slug: "pennsylvania-comparative-negligence-51-percent-bar-rule-explained" },
  { label: "Limited Tort vs. Full Tort", slug: "limited-tort-vs-full-tort-pennsylvania" },
  { label: "First-Party Benefits (PIP)", slug: "pennsylvania-first-party-benefits-pip-medical-coverage" },
  { label: "What to Do After an Accident", slug: "what-to-do-immediately-after-car-accident-pennsylvania" },
  { label: "Talking to Insurance Adjusters", slug: "dealing-with-insurance-adjusters-after-pa-accident" },
  { label: "UM/UIM Coverage Guide", slug: "um-uim-coverage-pennsylvania-uninsured-underinsured-motorists" },
];

// Top accident-type hubs to surface from every city page.
export const TOP_ACCIDENT_HUBS = [
  { label: "Car Accidents", slug: "car-accidents" },
  { label: "Truck Accidents", slug: "truck-accidents" },
  { label: "Motorcycle Accidents", slug: "motorcycle-accidents" },
  { label: "Pedestrian Accidents", slug: "pedestrian-accidents" },
  { label: "Slip & Fall", slug: "slip-and-fall" },
  { label: "Wrongful Death", slug: "wrongful-death" },
];

// Each accident-type hub -> a small curated set of the most relevant guides.
export const ACCIDENT_GUIDE_LINKS = {
  "car-accidents": [
    { label: "Pennsylvania Car Accident Guide", slug: "pennsylvania-car-accident-guide-what-to-do-claims-work" },
    { label: "What to Do Immediately After a Crash", slug: "what-to-do-immediately-after-car-accident-pennsylvania" },
    { label: "Who Pays My Medical Bills?", slug: "who-pays-medical-bills-pennsylvania-car-accident" },
    { label: "Limited Tort vs. Full Tort", slug: "limited-tort-vs-full-tort-pennsylvania" },
  ],
  "truck-accidents": [
    { label: "Pennsylvania Truck Accident Guide", slug: "pennsylvania-truck-accident-guide-liability-evidence-deadlines" },
    { label: "Truck Driver Fatigue & Hours-of-Service", slug: "truck-driver-fatigue-hours-of-service-violations-pennsylvania" },
    { label: "Statute of Limitations", slug: "pennsylvania-statute-of-limitations-injury-claims-explained" },
  ],
  "motorcycle-accidents": [
    { label: "Pennsylvania Motorcycle Accident Guide", slug: "pennsylvania-motorcycle-accident-guide-laws-helmets-recovery" },
    { label: "Left-Turn Motorcycle Crashes", slug: "left-turn-motorcycle-accidents-pennsylvania" },
    { label: "Limited Tort vs. Full Tort", slug: "limited-tort-vs-full-tort-pennsylvania" },
  ],
  "pedestrian-accidents": [
    { label: "Pennsylvania Pedestrian Accident Guide", slug: "pennsylvania-pedestrian-accident-crosswalks-tort-rights" },
    { label: "UM/UIM Coverage", slug: "um-uim-coverage-pennsylvania-uninsured-underinsured-motorists" },
    { label: "What to Do After an Accident", slug: "what-to-do-immediately-after-car-accident-pennsylvania" },
  ],
  "bicycle-accidents": [
    { label: "Pennsylvania's Four-Foot Passing Law", slug: "pennsylvania-four-foot-passing-law-bicycle-accidents" },
    { label: "Pedestrian & Crosswalk Rights", slug: "pennsylvania-pedestrian-accident-crosswalks-tort-rights" },
    { label: "Comparative Negligence (51% Bar)", slug: "pennsylvania-comparative-negligence-51-percent-bar-rule-explained" },
  ],
  "rideshare-accidents": [
    { label: "Uber & Lyft Accident Guide", slug: "uber-lyft-accident-guide-pennsylvania-riders" },
    { label: "UM/UIM Coverage", slug: "um-uim-coverage-pennsylvania-uninsured-underinsured-motorists" },
    { label: "Who Pays My Medical Bills?", slug: "who-pays-medical-bills-pennsylvania-car-accident" },
  ],
  "slip-and-fall": [
    { label: "Slip & Fall: Hills and Ridges Rule", slug: "pennsylvania-slip-fall-proving-fault-hills-ridges-rule" },
    { label: "Snow & Ice Slip and Fall Claims", slug: "snow-ice-slip-fall-claims-pennsylvania" },
    { label: "Comparative Negligence (51% Bar)", slug: "pennsylvania-comparative-negligence-51-percent-bar-rule-explained" },
  ],
  "dog-bites": [
    { label: "Pennsylvania Dog Bite Guide", slug: "pennsylvania-dog-bite-strict-liability-rights" },
    { label: "Statute of Limitations", slug: "pennsylvania-statute-of-limitations-injury-claims-explained" },
    { label: "Choosing the Right Attorney", slug: "how-to-choose-pennsylvania-personal-injury-attorney" },
  ],
  "wrongful-death": [
    { label: "Pennsylvania Wrongful Death Guide", slug: "pennsylvania-wrongful-death-claims-beneficiaries-damages" },
    { label: "Statute of Limitations", slug: "pennsylvania-statute-of-limitations-injury-claims-explained" },
    { label: "What Is My Case Worth?", slug: "what-is-my-pennsylvania-injury-case-worth" },
  ],
  "catastrophic-injuries": [
    { label: "Catastrophic Injury & Serious-Injury Threshold", slug: "pennsylvania-catastrophic-injury-serious-injury-threshold-guide" },
    { label: "Spinal Cord Injury Claims", slug: "spinal-cord-injury-claims-pennsylvania" },
    { label: "Traumatic Brain Injury Claims", slug: "traumatic-brain-injury-claims-pennsylvania" },
  ],
  "traumatic-brain-injury": [
    { label: "Traumatic Brain Injury Claims", slug: "traumatic-brain-injury-claims-pennsylvania" },
    { label: "Catastrophic Injury Threshold", slug: "pennsylvania-catastrophic-injury-serious-injury-threshold-guide" },
    { label: "What Is My Case Worth?", slug: "what-is-my-pennsylvania-injury-case-worth" },
  ],
  "product-liability": [
    { label: "Product Liability & the Tincher Standard", slug: "pennsylvania-product-liability-defective-products-tincher" },
    { label: "Statute of Limitations", slug: "pennsylvania-statute-of-limitations-injury-claims-explained" },
    { label: "Choosing the Right Attorney", slug: "how-to-choose-pennsylvania-personal-injury-attorney" },
  ],
  "medical-malpractice": [
    { label: "Medical Malpractice: Certificate of Merit & MCARE", slug: "pennsylvania-medical-malpractice-certificate-merit-mcare-fund" },
    { label: "Statute of Limitations", slug: "pennsylvania-statute-of-limitations-injury-claims-explained" },
    { label: "What Is My Case Worth?", slug: "what-is-my-pennsylvania-injury-case-worth" },
  ],
  "construction-accidents": [
    { label: "Construction: Workers' Comp vs. Third-Party", slug: "pennsylvania-construction-accident-workers-comp-third-party-claims" },
    { label: "Workers' Comp & Injury Claims", slug: "workers-compensation-personal-injury-claims-pennsylvania" },
    { label: "Statute of Limitations", slug: "pennsylvania-statute-of-limitations-injury-claims-explained" },
  ],
  "premises-liability": [
    { label: "Slip & Fall: Hills and Ridges Rule", slug: "pennsylvania-slip-fall-proving-fault-hills-ridges-rule" },
    { label: "Snow & Ice Slip and Fall Claims", slug: "snow-ice-slip-fall-claims-pennsylvania" },
    { label: "Comparative Negligence (51% Bar)", slug: "pennsylvania-comparative-negligence-51-percent-bar-rule-explained" },
  ],
  "hit-and-run-accidents": [
    { label: "Hit and Run: Using Your Own Coverage", slug: "hit-and-run-accidents-pennsylvania-using-own-coverage" },
    { label: "UM/UIM Coverage", slug: "um-uim-coverage-pennsylvania-uninsured-underinsured-motorists" },
    { label: "Stacking UM/UIM Coverage", slug: "stacking-um-uim-coverage-pennsylvania" },
  ],
};
